module.exports = __webpack_public_path__ + "media/images/logo-blue-with-name-440675ef9cc4d2deead06cbee55245fb.svg";